import { Action } from 'redux';

import { PublishToSalesforce } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface PublishToSalesforceAction extends Action {
  content: IContentInfo[];
}

export function publishToSalesforce(content: IContentInfo[]): PublishToSalesforceAction {
  return {
    type: PublishToSalesforce,
    content: content,
  };
}

export const isPublishToSalesforceAction = isActionFactory<PublishToSalesforceAction>(PublishToSalesforce);